import {useCallback,  useMemo, useState} from "react";
import {fetchJson} from "../../utils";
import type {ProductType, UseWishListReturnType, WishListItemType} from "../../types";
import {useAppState} from "../../context";

export const useWishList = (): UseWishListReturnType => {


    const [loading, setLoading] = useState(false);
    const [wishlist, setWishlist] = useAppState<WishListItemType[]>('wishlist', []);


    const addToWishlist = useCallback((product: ProductType) => {
        fetchJson<WishListItemType[]>('/api/wishlist/add', {
            method: 'POST',
            body: JSON.stringify({
                product: product.id,
            })
        })
            .then(({json}) => {
                setWishlist(json);
            })
            .finally(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error(error);
            });
    }, []);

    const removeFromWishlist = useCallback((product: ProductType) => {
        fetchJson<WishListItemType[]>('/api/wishlist/remove', {
            method: 'POST',
            body: JSON.stringify({
                product: product.id,
            })
        })
            .then(({json}) => {
                setWishlist(json);
            })
            .finally(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error(error);
            });
    }, []);

    const isInWishlist = (product: ProductType) => {
        return wishlist.find(v => v.product.id === product.id) !== undefined;
    }

    return useMemo(() => {
        return {
            loading,
            wishlist,
            addToWishlist,
            removeFromWishlist,
            isInWishlist
        };
    }, [loading, wishlist]);
}

export default useWishList;